<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="tw-p-[40px] tw-bg-white">
    <span class="tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
      >{{
        getComponentUiText(
          "app-modal-create-a-new-vendor-assessment-complete-section-subtitle-1",
        )
      }}
      <span class="tw-ml-[10px]">
        <ButtonShowDuplicateAssessment
          :id-popover="'popover-vendor-assessment-complete-section'"
        ></ButtonShowDuplicateAssessment>
      </span>
    </span>
    <div
      class="tw-mt-[10px] tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-leading-[145%]"
    >
      {{
        getComponentUiText(
          "app-modal-create-a-new-vendor-assessment-complete-section-hint-1",
        )
      }}
    </div>
    <div
      class="tw-mt-[40px] tw-p-[40px] tw-flex-col tw-gap-[13px] tw-items-start tw-justify-center box-shadow tw-rounded-[4px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#F7F7F8]"
    >
      <p class="tw-text-[18px] tw-font-[600] tw-text-[#211F58] tw-mb-[10px]">
        {{
          getComponentUiText(
            "app-modal-create-a-new-vendor-assessment-complete-section-secret-1",
          )
        }}
      </p>
      <div
        class="tw-text-[#231F20] tw-text-[15px] tw-font-[400] tw-leading-[145%]"
        v-html="hintTex"
      />

      <CopyInfo
        class="!tw-max-w-[100%] !tw-w-[100%] tw-py-[14px] tw-mt-[25px] tw-px-[20px] tw-bg-[#FFFFFF] tw-rounded-md"
        :text="secret"
        :style-icon-css="'tw-w-[18px] tw-h-[18px]'"
        text-class="tw-text-[15px] tw-font-[400] tw-leading-[145%] tw-text-[#231F20]"
        alert-class="!tw-right-[50px] !tw-top-[40px]"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import CopyInfo from "@/components/common/copyInfo.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";

defineProps({
  secret: {
    type: String,
    required: true,
  },
});
const hintTex = getComponentUiText(
  "app-modal-create-a-new-vendor-assessment-complete-section-helper-text-1",
  false,
  {
    completeText: {
      value: `'${getComponentUiText(
        "app-profile-modal-update-email-address-button-1",
      )}'`,
      css: "tw-text-[#231F20] tw-font-[600]",
    },
  },
);
const emit = defineEmits([
  "update:show",
  "update:domain",
  "delete:domain",
  "update:close",
]);
</script>

<style lang="scss" scoped>
.text-copy-container {
  width: calc(100% - 22px);
}

.copy-info-container {
  width: 70%;
}

.button-delete {
  line-height: 100%;
  background-color: #f7553c;
  border-color: #f7553c;
}

.button-verify-later {
  line-height: 100%;
  border: 2px solid #387dff;
  background-color: #ffffff;
  color: #387dff !important;
}

.button-verify {
  line-height: 100%;
  background-color: #387dff;
  border-color: #387dff;
}

@media (max-width: 870px) {
  .hint-text {
    padding-right: 40px !important;
  }
}

.hint-text {
  padding-right: 180px;
}
.box-shadow {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
</style>
